import { GET_RECEIVED_SKIDS_BARCODES } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_RECEIVED_SKIDS_BARCODES:
            return action.payload;
        default:
            return state;
    }
}